import { concat } from '../../helpers/common'

const MODULE_NAME = 'GOOGLE_AD_MANAGER/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

export const GET_GOOGLE_AD_MANAGER_AD_UNITS = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNITS')
export const GET_GOOGLE_AD_MANAGER_AD_UNITS_SUCCESS = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNITS_SUCCESS')
export const GET_GOOGLE_AD_MANAGER_AD_UNITS_FAILURE = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNITS_FAILURE')
export const CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNITS = concat(MODULE_NAME, 'CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNITS')

export const GET_GOOGLE_AD_MANAGER_AD_UNIT = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNIT')
export const GET_GOOGLE_AD_MANAGER_AD_UNIT_SUCCESS = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNIT_SUCCESS')
export const GET_GOOGLE_AD_MANAGER_AD_UNIT_FAILURE = concat(MODULE_NAME, 'GET_GOOGLE_AD_MANAGER_AD_UNIT_FAILURE')
export const CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNIT = concat(MODULE_NAME, 'CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNIT')

export const GET_ONSITE_RATES = concat(MODULE_NAME, 'GET_ONSITE_RATES')
export const GET_ONSITE_RATES_SUCCESS = concat(MODULE_NAME, 'GET_ONSITE_RATES_SUCCESS')
export const GET_ONSITE_RATES_FAILURE = concat(MODULE_NAME, 'GET_ONSITE_RATES_FAILURE')
export const CLEAR_GET_ONSITE_RATES = concat(MODULE_NAME, 'CLEAR_GET_ONSITE_RATES')

export const CREATE_BULK_GAM_LINE_ITEMS = concat(MODULE_NAME, 'CREATE_BULK_GAM_LINE_ITEMS')
export const CREATE_BULK_GAM_LINE_ITEMS_SUCCESS = concat(MODULE_NAME, 'CREATE_BULK_GAM_LINE_ITEMS_SUCCESS')
export const CREATE_BULK_GAM_LINE_ITEMS_FAILURE = concat(MODULE_NAME, 'CREATE_BULK_GAM_LINE_ITEMS_FAILURE')
export const CLEAR_CREATE_BULK_GAM_LINE_ITEMS = concat(MODULE_NAME, 'CLEAR_CREATE_BULK_GAM_LINE_ITEMS')

export const CREATE_GAM_LINE_ITEM_FORECAST = concat(MODULE_NAME, 'CREATE_GAM_LINE_ITEM_FORECAST')
export const CREATE_GAM_LINE_ITEM_FORECAST_SUCCESS = concat(MODULE_NAME, 'CREATE_GAM_LINE_ITEM_FORECAST_SUCCESS')
export const CREATE_GAM_LINE_ITEM_FORECAST_FAILURE = concat(MODULE_NAME, 'CREATE_GAM_LINE_ITEM_FORECAST_FAILURE')
export const CLEAR_CREATE_GAM_LINE_ITEM_FORECAST = concat(MODULE_NAME, 'CLEAR_CREATE_GAM_LINE_ITEM_FORECAST')

export const GET_GAM_AD_UNIT_SIZES = concat(MODULE_NAME, 'GET_GAM_AD_UNIT_SIZES')
export const GET_GAM_AD_UNIT_SIZES_SUCCESS = concat(MODULE_NAME, 'GET_GAM_AD_UNIT_SIZES_SUCCESS')
export const GET_GAM_AD_UNIT_SIZES_FAILURE = concat(MODULE_NAME, 'GET_GAM_AD_UNIT_SIZES_FAILURE')
export const CLEAR_GET_GAM_AD_UNIT_SIZES = concat(MODULE_NAME, 'CLEAR_GET_GAM_AD_UNIT_SIZES')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// Get google ad manager ad units
export function getGoogleAdManagerAdUnits(params) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNITS, params }
}

export function getGoogleAdManagerAdUnitsSuccess(data) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNITS_SUCCESS, data }
}

export function getGoogleAdManagerAdUnitsFailure(error) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNITS_FAILURE, error }
}

export function clearGetGoogleAdManagerAdUnits() {
  return { type: CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNITS }
}

// Get google ad manager ad unit
export function getGoogleAdManagerAdUnit(params) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNIT, params }
}

export function getGoogleAdManagerAdUnitSuccess(data) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNIT_SUCCESS, data }
}

export function getGoogleAdManagerAdUnitFailure(error) {
  return { type: GET_GOOGLE_AD_MANAGER_AD_UNIT_FAILURE, error }
}

export function clearGetGoogleAdManagerAdUnit() {
  return { type: CLEAR_GET_GOOGLE_AD_MANAGER_AD_UNIT }
}

// Get onsite rates
export function getOnsiteRates(params) {
  return { type: GET_ONSITE_RATES, params }
}

export function getOnsiteRatesSuccess(data) {
  return { type: GET_ONSITE_RATES_SUCCESS, data }
}

export function getOnsiteRatesFailure(error) {
  return { type: GET_ONSITE_RATES_FAILURE, error }
}

export function clearGetOnsiteRates() {
  return { type: CLEAR_GET_ONSITE_RATES }
}

// Create bulk gam line items
export function createBulkGamLineItems(data) {
  return { type: CREATE_BULK_GAM_LINE_ITEMS, data }
}

export function createBulkGamLineItemsSuccess(data) {
  return { type: CREATE_BULK_GAM_LINE_ITEMS_SUCCESS, data }
}

export function createBulkGamLineItemsFailure(error) {
  return { type: CREATE_BULK_GAM_LINE_ITEMS_FAILURE, error }
}

export function clearCreateBulkGamLineItems() {
  return { type: CLEAR_CREATE_BULK_GAM_LINE_ITEMS }
}

// Create gam line item forecast
export function createGamLineItemForecast(data) {
  return { type: CREATE_GAM_LINE_ITEM_FORECAST, data }
}

export function createGamLineItemForecastSuccess(data) {
  return { type: CREATE_GAM_LINE_ITEM_FORECAST_SUCCESS, data }
}

export function createGamLineItemForecastFailure(error) {
  return { type: CREATE_GAM_LINE_ITEM_FORECAST_FAILURE, error }
}

export function clearCreateGamLineItemForecast() {
  return { type: CLEAR_CREATE_GAM_LINE_ITEM_FORECAST }
}

// Get gam ad units
export function getGamAdUnitSizes(params) {
  return { type: GET_GAM_AD_UNIT_SIZES, params }
}

export function getGamAdUnitSizesSuccess(data) {
  return { type: GET_GAM_AD_UNIT_SIZES_SUCCESS, data }
}

export function getGamAdUnitSizesFailure(error) {
  return { type: GET_GAM_AD_UNIT_SIZES_FAILURE, error }
}

export function clearGetGamAdUnitSizes() {
  return { type: CLEAR_GET_GAM_AD_UNIT_SIZES }
}
